export default __webpack_public_path__ + "9a95c306ce3719f373d2573b9f36da8a.png";